import React from "react";
import {
  Container,
  Divider,
  Typography,
  Link as MuiLink,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  footer: {
    marginTop: "100px",
    marginBottom: "10px",
    backgroundColor: "whitesmoke",
    flex: 1
  },
}));

const DATE = new Date();

function Footer({ typograpy }) {
  const classes = useStyles();

  return (
    <Container className={classes.footer}>
      <Divider />
      <Typography variant={typograpy ? typograpy : "caption"}>
        © {DATE.getFullYear()} Bhaskar Nar, All rights reserved.
      </Typography>

      <Container>
        <MuiLink component={Link} to="#">
          <Typography variant="caption">Terms of Service</Typography>
        </MuiLink>

        <Divider orientation="vertical" />
        <MuiLink component={Link} to="#">
          <Typography variant="caption">Privacy Policy</Typography>
        </MuiLink>
      </Container>
    </Container>
  );
}

export default Footer;
